import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Typography from 'APP/Converse/Typography'
import styled from 'styled-components/native'

const TILE_SIZE = 160

export const ContentContainer = styled(DialogueTouchableOpacity)<{
  isError: boolean
  isInline?: boolean
}>`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, isError }) =>
    isError ? theme.colors.elementBgError : theme.colors.elementsBg};
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small}px;
  border-width: 1px;
  border-style: dashed;
  border-color: ${({ theme, isError }) =>
    isError ? theme.colors.error : theme.colors.elementsBorder};
  width: 100%;
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  gap: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  align-self: stretch;
  ${({ theme, isInline }) =>
    isInline ? 'flex: 1;' : `min-height: ${TILE_SIZE + theme.metrics.baseMargin * 2.5}px;`}
`

export const LoadingContainer = styled.View<{ isError: boolean }>`
  width: 100%;
  min-height: ${TILE_SIZE}px;
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small}px;
  border-width: 1px;
  border-style: dashed;
  border-color: ${({ theme, isError }) =>
    isError ? theme.colors.error : theme.colors.elementsBorder};
  background-color: ${({ theme }) => theme.colors.elementsBg};
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

export const FilesRow = styled.View<{ justifyContent: 'space-between' | 'flex-start' }>`
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent};
`

export const CenteredInstructionText = styled(Typography).attrs(() => ({
  variant: 'bodyLarge',
  color: 'text',
}))`
  text-align: center;
`
export const CenteredRequirement = styled(Typography).attrs(() => ({
  variant: 'bodySmall',
  color: 'dim',
}))`
  text-align: center;
`
